/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { EmployeeImportCompanyPreviewDto } from '../models';
// @ts-ignore
import type { GetDataUpdateByFileResponseDto } from '../models';
// @ts-ignore
import type { InlineObjectDto } from '../models';
// @ts-ignore
import type { UpdateDataRequestFileTypeDto } from '../models';
/**
 * ApplicationDataUpdateApi - axios parameter creator
 * @export
 */
export const ApplicationDataUpdateApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get status of uploading data by file
         * @param {string} uploadByFileStatusId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUploadDataFileStatus: async (uploadByFileStatusId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uploadByFileStatusId' is not null or undefined
            assertParamExists('getUploadDataFileStatus', 'uploadByFileStatusId', uploadByFileStatusId)
            const localVarPath = `/api/v2/application-data/update-by-file`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (uploadByFileStatusId !== undefined) {
                localVarQueryParameter['uploadByFileStatusId'] = uploadByFileStatusId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Skanuje kolumny Company i Pers No pliku pracowników i zwraca spółki, które w nim wystąpiły, wraz z liczbą wierszy, oraz aktywne osoby z tych spółek, których w pliku nie ma. Nic nie zapisuje - służy wyłącznie do zbudowania dialogu przed właściwym importem. Plik jest wysyłany ponownie w żądaniu importu.
         * @summary Preview the companies present in an EMPLOYEES file
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        previewEmployeeImportCompanies: async (file: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'file' is not null or undefined
            assertParamExists('previewEmployeeImportCompanies', 'file', file)
            const localVarPath = `/api/v2/application-data/employees/company-preview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Upload data
         * @param {File} file 
         * @param {UpdateDataRequestFileTypeDto} dataType 
         * @param {Array<string>} [companies] Spółki, których pracownicy mają zostać zaimportowani - wybrane przez administratora spośród spółek znalezionych w pliku (patrz previewEmployeeImportCompanies). Dotyczy wyłącznie EMPLOYEES; pozostałe typy plików pomijają ten parametr. JMD jest importowane zawsze, niezależnie od zawartości listy.
         * @param {boolean} [deactivateMissing] Dotyczy wyłącznie EMPLOYEES. Gdy true, przy starcie importu zapamiętywana jest lista osób, które previewEmployeeImportCompanies (missingEmployees) zwraca dla tego pliku i importowanych spółek. Import oznacza jako nieaktywne tylko osoby z tej listy, których plik nadal nie zawiera. Lista przeżywa wznowienie importu po rozwiązaniu problemów walidacyjnych, a podmiana pliku jej nie poszerza. Domyślnie false.
         * @param {number} [editionYear] Rok edycji podawany w dialogu importu. Wymagany dla DEVELOPMENT_CENTER — razem z positionName wyznacza edycję, którą import nadpisuje (nowa wersja).
         * @param {string} [positionName] Nazwa stanowiska, którego dotyczy plik (np. SSM). Wymagana dla DEVELOPMENT_CENTER.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadDataByFile: async (file: File, dataType: UpdateDataRequestFileTypeDto, companies?: Array<string>, deactivateMissing?: boolean, editionYear?: number, positionName?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'file' is not null or undefined
            assertParamExists('uploadDataByFile', 'file', file)
            // verify required parameter 'dataType' is not null or undefined
            assertParamExists('uploadDataByFile', 'dataType', dataType)
            const localVarPath = `/api/v2/application-data/update-by-file`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            if (companies) {
                localVarQueryParameter['companies'] = companies.join(COLLECTION_FORMATS.csv);
            }

            if (deactivateMissing !== undefined) {
                localVarQueryParameter['deactivateMissing'] = deactivateMissing;
            }


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
            if (dataType !== undefined) { 
                localVarFormParams.append('dataType', dataType as any);
            }
    
            if (editionYear !== undefined) { 
                localVarFormParams.append('editionYear', editionYear as any);
            }
    
            if (positionName !== undefined) { 
                localVarFormParams.append('positionName', positionName as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ApplicationDataUpdateApi - functional programming interface
 * @export
 */
export const ApplicationDataUpdateApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ApplicationDataUpdateApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get status of uploading data by file
         * @param {string} uploadByFileStatusId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUploadDataFileStatus(uploadByFileStatusId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetDataUpdateByFileResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUploadDataFileStatus(uploadByFileStatusId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ApplicationDataUpdateApi.getUploadDataFileStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Skanuje kolumny Company i Pers No pliku pracowników i zwraca spółki, które w nim wystąpiły, wraz z liczbą wierszy, oraz aktywne osoby z tych spółek, których w pliku nie ma. Nic nie zapisuje - służy wyłącznie do zbudowania dialogu przed właściwym importem. Plik jest wysyłany ponownie w żądaniu importu.
         * @summary Preview the companies present in an EMPLOYEES file
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async previewEmployeeImportCompanies(file: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmployeeImportCompanyPreviewDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.previewEmployeeImportCompanies(file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ApplicationDataUpdateApi.previewEmployeeImportCompanies']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Upload data
         * @param {File} file 
         * @param {UpdateDataRequestFileTypeDto} dataType 
         * @param {Array<string>} [companies] Spółki, których pracownicy mają zostać zaimportowani - wybrane przez administratora spośród spółek znalezionych w pliku (patrz previewEmployeeImportCompanies). Dotyczy wyłącznie EMPLOYEES; pozostałe typy plików pomijają ten parametr. JMD jest importowane zawsze, niezależnie od zawartości listy.
         * @param {boolean} [deactivateMissing] Dotyczy wyłącznie EMPLOYEES. Gdy true, przy starcie importu zapamiętywana jest lista osób, które previewEmployeeImportCompanies (missingEmployees) zwraca dla tego pliku i importowanych spółek. Import oznacza jako nieaktywne tylko osoby z tej listy, których plik nadal nie zawiera. Lista przeżywa wznowienie importu po rozwiązaniu problemów walidacyjnych, a podmiana pliku jej nie poszerza. Domyślnie false.
         * @param {number} [editionYear] Rok edycji podawany w dialogu importu. Wymagany dla DEVELOPMENT_CENTER — razem z positionName wyznacza edycję, którą import nadpisuje (nowa wersja).
         * @param {string} [positionName] Nazwa stanowiska, którego dotyczy plik (np. SSM). Wymagana dla DEVELOPMENT_CENTER.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadDataByFile(file: File, dataType: UpdateDataRequestFileTypeDto, companies?: Array<string>, deactivateMissing?: boolean, editionYear?: number, positionName?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetDataUpdateByFileResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadDataByFile(file, dataType, companies, deactivateMissing, editionYear, positionName, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ApplicationDataUpdateApi.uploadDataByFile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ApplicationDataUpdateApi - factory interface
 * @export
 */
export const ApplicationDataUpdateApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ApplicationDataUpdateApiFp(configuration)
    return {
        /**
         * 
         * @summary Get status of uploading data by file
         * @param {string} uploadByFileStatusId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUploadDataFileStatus(uploadByFileStatusId: string, options?: RawAxiosRequestConfig): AxiosPromise<GetDataUpdateByFileResponseDto> {
            return localVarFp.getUploadDataFileStatus(uploadByFileStatusId, options).then((request) => request(axios, basePath));
        },
        /**
         * Skanuje kolumny Company i Pers No pliku pracowników i zwraca spółki, które w nim wystąpiły, wraz z liczbą wierszy, oraz aktywne osoby z tych spółek, których w pliku nie ma. Nic nie zapisuje - służy wyłącznie do zbudowania dialogu przed właściwym importem. Plik jest wysyłany ponownie w żądaniu importu.
         * @summary Preview the companies present in an EMPLOYEES file
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        previewEmployeeImportCompanies(file: File, options?: RawAxiosRequestConfig): AxiosPromise<EmployeeImportCompanyPreviewDto> {
            return localVarFp.previewEmployeeImportCompanies(file, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Upload data
         * @param {File} file 
         * @param {UpdateDataRequestFileTypeDto} dataType 
         * @param {Array<string>} [companies] Spółki, których pracownicy mają zostać zaimportowani - wybrane przez administratora spośród spółek znalezionych w pliku (patrz previewEmployeeImportCompanies). Dotyczy wyłącznie EMPLOYEES; pozostałe typy plików pomijają ten parametr. JMD jest importowane zawsze, niezależnie od zawartości listy.
         * @param {boolean} [deactivateMissing] Dotyczy wyłącznie EMPLOYEES. Gdy true, przy starcie importu zapamiętywana jest lista osób, które previewEmployeeImportCompanies (missingEmployees) zwraca dla tego pliku i importowanych spółek. Import oznacza jako nieaktywne tylko osoby z tej listy, których plik nadal nie zawiera. Lista przeżywa wznowienie importu po rozwiązaniu problemów walidacyjnych, a podmiana pliku jej nie poszerza. Domyślnie false.
         * @param {number} [editionYear] Rok edycji podawany w dialogu importu. Wymagany dla DEVELOPMENT_CENTER — razem z positionName wyznacza edycję, którą import nadpisuje (nowa wersja).
         * @param {string} [positionName] Nazwa stanowiska, którego dotyczy plik (np. SSM). Wymagana dla DEVELOPMENT_CENTER.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadDataByFile(file: File, dataType: UpdateDataRequestFileTypeDto, companies?: Array<string>, deactivateMissing?: boolean, editionYear?: number, positionName?: string, options?: RawAxiosRequestConfig): AxiosPromise<GetDataUpdateByFileResponseDto> {
            return localVarFp.uploadDataByFile(file, dataType, companies, deactivateMissing, editionYear, positionName, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ApplicationDataUpdateApi - interface
 * @export
 * @interface ApplicationDataUpdateApi
 */
export interface ApplicationDataUpdateApiInterface {
    /**
     * 
     * @summary Get status of uploading data by file
     * @param {string} uploadByFileStatusId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationDataUpdateApiInterface
     */
    getUploadDataFileStatus(uploadByFileStatusId: string, options?: RawAxiosRequestConfig): AxiosPromise<GetDataUpdateByFileResponseDto>;

    /**
     * Skanuje kolumny Company i Pers No pliku pracowników i zwraca spółki, które w nim wystąpiły, wraz z liczbą wierszy, oraz aktywne osoby z tych spółek, których w pliku nie ma. Nic nie zapisuje - służy wyłącznie do zbudowania dialogu przed właściwym importem. Plik jest wysyłany ponownie w żądaniu importu.
     * @summary Preview the companies present in an EMPLOYEES file
     * @param {File} file 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationDataUpdateApiInterface
     */
    previewEmployeeImportCompanies(file: File, options?: RawAxiosRequestConfig): AxiosPromise<EmployeeImportCompanyPreviewDto>;

    /**
     * 
     * @summary Upload data
     * @param {File} file 
     * @param {UpdateDataRequestFileTypeDto} dataType 
     * @param {Array<string>} [companies] Spółki, których pracownicy mają zostać zaimportowani - wybrane przez administratora spośród spółek znalezionych w pliku (patrz previewEmployeeImportCompanies). Dotyczy wyłącznie EMPLOYEES; pozostałe typy plików pomijają ten parametr. JMD jest importowane zawsze, niezależnie od zawartości listy.
     * @param {boolean} [deactivateMissing] Dotyczy wyłącznie EMPLOYEES. Gdy true, przy starcie importu zapamiętywana jest lista osób, które previewEmployeeImportCompanies (missingEmployees) zwraca dla tego pliku i importowanych spółek. Import oznacza jako nieaktywne tylko osoby z tej listy, których plik nadal nie zawiera. Lista przeżywa wznowienie importu po rozwiązaniu problemów walidacyjnych, a podmiana pliku jej nie poszerza. Domyślnie false.
     * @param {number} [editionYear] Rok edycji podawany w dialogu importu. Wymagany dla DEVELOPMENT_CENTER — razem z positionName wyznacza edycję, którą import nadpisuje (nowa wersja).
     * @param {string} [positionName] Nazwa stanowiska, którego dotyczy plik (np. SSM). Wymagana dla DEVELOPMENT_CENTER.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationDataUpdateApiInterface
     */
    uploadDataByFile(file: File, dataType: UpdateDataRequestFileTypeDto, companies?: Array<string>, deactivateMissing?: boolean, editionYear?: number, positionName?: string, options?: RawAxiosRequestConfig): AxiosPromise<GetDataUpdateByFileResponseDto>;

}

/**
 * ApplicationDataUpdateApi - object-oriented interface
 * @export
 * @class ApplicationDataUpdateApi
 * @extends {BaseAPI}
 */
export class ApplicationDataUpdateApi extends BaseAPI implements ApplicationDataUpdateApiInterface {
    /**
     * 
     * @summary Get status of uploading data by file
     * @param {string} uploadByFileStatusId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationDataUpdateApi
     */
    public getUploadDataFileStatus(uploadByFileStatusId: string, options?: RawAxiosRequestConfig) {
        return ApplicationDataUpdateApiFp(this.configuration).getUploadDataFileStatus(uploadByFileStatusId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Skanuje kolumny Company i Pers No pliku pracowników i zwraca spółki, które w nim wystąpiły, wraz z liczbą wierszy, oraz aktywne osoby z tych spółek, których w pliku nie ma. Nic nie zapisuje - służy wyłącznie do zbudowania dialogu przed właściwym importem. Plik jest wysyłany ponownie w żądaniu importu.
     * @summary Preview the companies present in an EMPLOYEES file
     * @param {File} file 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationDataUpdateApi
     */
    public previewEmployeeImportCompanies(file: File, options?: RawAxiosRequestConfig) {
        return ApplicationDataUpdateApiFp(this.configuration).previewEmployeeImportCompanies(file, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Upload data
     * @param {File} file 
     * @param {UpdateDataRequestFileTypeDto} dataType 
     * @param {Array<string>} [companies] Spółki, których pracownicy mają zostać zaimportowani - wybrane przez administratora spośród spółek znalezionych w pliku (patrz previewEmployeeImportCompanies). Dotyczy wyłącznie EMPLOYEES; pozostałe typy plików pomijają ten parametr. JMD jest importowane zawsze, niezależnie od zawartości listy.
     * @param {boolean} [deactivateMissing] Dotyczy wyłącznie EMPLOYEES. Gdy true, przy starcie importu zapamiętywana jest lista osób, które previewEmployeeImportCompanies (missingEmployees) zwraca dla tego pliku i importowanych spółek. Import oznacza jako nieaktywne tylko osoby z tej listy, których plik nadal nie zawiera. Lista przeżywa wznowienie importu po rozwiązaniu problemów walidacyjnych, a podmiana pliku jej nie poszerza. Domyślnie false.
     * @param {number} [editionYear] Rok edycji podawany w dialogu importu. Wymagany dla DEVELOPMENT_CENTER — razem z positionName wyznacza edycję, którą import nadpisuje (nowa wersja).
     * @param {string} [positionName] Nazwa stanowiska, którego dotyczy plik (np. SSM). Wymagana dla DEVELOPMENT_CENTER.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationDataUpdateApi
     */
    public uploadDataByFile(file: File, dataType: UpdateDataRequestFileTypeDto, companies?: Array<string>, deactivateMissing?: boolean, editionYear?: number, positionName?: string, options?: RawAxiosRequestConfig) {
        return ApplicationDataUpdateApiFp(this.configuration).uploadDataByFile(file, dataType, companies, deactivateMissing, editionYear, positionName, options).then((request) => request(this.axios, this.basePath));
    }
}

